export const dayStart = d => {
	let date = createDate(d);
	return dateToString(date)
}
export const dayEnd = d => {
	let date = createDate(d);
	date.setDate(date.getDate() + 1)
	return dateToString(date)
}
export const weekStart = d => {
	let date = createDate(d);
    // console.log(date);
	let weekstart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - date.getDay());
	return dateToString(weekstart);
}
//本周一
const OnMonday = (d)=>{
    let date = createDate(d);
	let weekstart = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1 - date.getDay());
    return weekstart
}
export const weekEnd = d => {
	let date = createDate(d);
	let weekend = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7 - date.getDay());
	return dateToString(weekend);
}
export const monthStart = d => {
	let date = createDate(d);
	let month = date.getMonth();
	let year = date.getFullYear();
	return dateToString(new Date(year, month, 1, 0))
}
export const monthEnd = d => {
	let date = createDate(d);
	let month = date.getMonth();
	let year = date.getFullYear();
	return dateToString(new Date(year, month + 1, 1, 0))
}
export const yearStart = d => {
	let date = createDate(d);
	let year = date.getFullYear();
	return dateToString(new Date(year, 0, 1, 0))
}
export const yearEnd = d => {
	let date = createDate(d);
	let year = date.getFullYear();
	return dateToString(new Date(year + 1, 0, 1, 0))
}
export const monthDays = d => {
	let date = new Date(d.getFullYear(), d.getMonth() + 1, 1);
	return (Number)(addDay(date, -1).toLocaleDateString().split('/')[2])
}
export const addDay = (d, num) => {
	let date = createDate(d);
	date.setDate(date.getDate() + num)
	return date
}

export const currentDay = d => {
	let date = createDate(d);
	return Number(date.toLocaleDateString().split('/')[2])
}

export const perDay = d => {
	let date = createDate(d);
	date.setDate(date.getDate() - 1)
	return date
}
export const nextDay = d => {
	let date = createDate(d);
	date.setDate(date.getDate() + 1)
	return date
}
export const perMonth = d => {
	let date = createDate(d);
	date.setMonth(date.getMonth() - 1)
	return date
}
export const nextMonth = d => {
	let date = createDate(d);
	date.setMonth(date.getMonth() + 1)
	return date
}

export const perYear = d => {
	let date = createDate(d);

	return new Date((date.getFullYear() - 1) + '')
}
export const nextYear = d => {
	let date = createDate(d);

	return new Date((date.getFullYear() + 1) + '')
}


function createDate(d) {
	return new Date(d.getTime())
}

function dateToString(d) {
    // console.log(d.toLocaleDateString());
	// return d.toLocaleDateString().replace(/\//g, '-') + 'T00:00:00Z'
    let time = d.toLocaleDateString().split('/').map(item =>{
        return item = item.length == 1? 0 + item :item
    }).join('-')
    return time + 'T00:00:00Z'
}


export function dateFormat(fmt, date) {
	let ret;
	const opt = {
		"Y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"H+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"S+": date.getSeconds().toString(), // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, "0"));
		}
	}
	return fmt;
}


//计算周
export function getAppointedDate(date,optType, optPageNum) {
	let obj = {}
      let now = date; //当前日期
      let nowDayOfWeek = now.getDay(); //今天本周的第几天
      let nowDay = now.getDate(); //当前日
      let nowMonth = now.getMonth(); //当前月
      let nowYear = now.getFullYear(); //当前年
      let lastMonth = nowMonth - 1;
      let startDate = '';
      let endDate = '';
      if (optType == 1) {
        startDate = formatDateFn(new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1 - (7 *
          optPageNum)))
        endDate = formatDateFn(new Date(nowYear, nowMonth, nowDay + 7 - nowDayOfWeek - (7 * optPageNum)))
      } else if (optType == 2) {
        startDate = formatDateFn(new Date(nowYear, lastMonth + 1 - (1 * optPageNum), 1))
        endDate = formatDateFn(new Date(nowYear, lastMonth + 1 - (1 * optPageNum), getMonthDays(
          nowYear, lastMonth + 1 - (1 * optPageNum))))
      }
      return obj = {
        startDate: startDate,
        endDate: endDate
      }
}
export function formatDateFn(date) {
	let myyear = date.getFullYear();
	let mymonth = date.getMonth() + 1;
	let myweekday = date.getDate();
	if (mymonth < 10) {
	  mymonth = "0" + mymonth;
	}
	if (myweekday < 10) {
	  myweekday = "0" + myweekday;
	}
	return (myyear + "-" + mymonth + "-" + myweekday);

}
// 获取最近7天的时间 
export const getLastOrNextFewDateBy =(value)=> {
    let timeList = []
    let receiver = []
    let timedate = value 
        for (let i = -6; i <= 0; i++) {
            let today = new Date();
            if (timedate) {
            receiver = timedate;
            } else {
            receiver = today;
            }
            let lastOrNextDate = receiver.getTime() + 1000 * 60 * 60 * 24 * i;
            today.setTime(lastOrNextDate);
            // var year = today.getFullYear();
            let month = today.getMonth() + 1;
            if (receiver == timedate) {
            let date = today.getDate();
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "/" + date )
            } else {
            let date = today.getDate() - 1;
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "/" + date)
            }
          
        }
        return timeList
    }

// 获取本周7天的时间 第一天为上周日
export const getWeekDays =(value)=> {
    let timeList = []
    let receiver = []
    let timedate = value 
        for (let i = -1; i <= 5; i++) {
            let today = OnMonday(new Date());
            
            if (timedate) {
            receiver = timedate;
            } else {
            receiver = today;
            }
            let lastOrNextDate = receiver.getTime() + 1000 * 60 * 60 * 24 * i;
            today.setTime(lastOrNextDate);
            // var year = today.getFullYear();
            let month = today.getMonth() + 1;
            if (receiver == timedate) {
            let date = today.getDate();
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "-" + date + 'T00:00:00Z')
            } else {
            let date = today.getDate() ;
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "-" + date + 'T00:00:00Z')
            }
          
        }
        return timeList
    }

// 获取本周7天的时间 第一天为本周一
export const getWeekDayArr =(value)=> {
    let timeList = []
    let receiver = []
    let timedate = value 
        for (let i = 0; i <= 6; i++) {
            let today = OnMonday(value);
            
            receiver = OnMonday(value);
            
            let lastOrNextDate = receiver.getTime() + 1000 * 60 * 60 * 24 * i;
            today.setTime(lastOrNextDate);
            // var year = today.getFullYear();
            let month = today.getMonth() + 1;
            if (receiver == timedate) {
            let date = today.getDate();
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "-" + date )
            } else {
            let date = today.getDate() ;
            if (date < 10) {
                date = '0' + date
            }
            if (month < 10) {
                month = '0' + month
            }
            timeList.push(month + "-" + date )
            }
          
        }
        return timeList
    }

    
    //传入日期例：2020-10-27T14:36:23
    export const  timeFormatSeconds = function(time) {
		var d = time ? new Date(time) : new Date();
		var year = d.getFullYear();
		var month = d.getMonth() + 1;
		var day = d.getDate();
		var hours = d.getHours();
		var min = d.getMinutes();
		var seconds = d.getSeconds();
 
		if (month < 10) month = '0' + month;
		if (day < 10) day = '0' + day;
		if (hours < 0) hours = '0' + hours;
		if (min < 10) min = '0' + min;
		if (seconds < 10) seconds = '0' + seconds;
 
		return (year + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + seconds);
}


export const getDiffDate = function(stime,etime){
    //初始化日期列表，数组
    var diffdate = new Array();
    var i=0;
    //开始日期小于等于结束日期,并循环
    while(stime<=etime){
        diffdate[i] = stime;
        
        //获取开始日期时间戳
        var stime_ts = new Date(stime).getTime();
        console.log('当前日期：'+stime   +'当前时间戳：'+stime_ts);
        
        //增加一天时间戳后的日期
        var next_date = stime_ts + (24*60*60*1000);
        
        //拼接年月日，这里的月份会返回（0-11），所以要+1
        var next_dates_y = new Date(next_date).getFullYear()+'-';
        var next_dates_m = (new Date(next_date).getMonth()+1 < 10)?'0'+(new Date(next_date).getMonth()+1)+'-':(new Date(next_date).getMonth()+1)+'-';
        var next_dates_d = (new Date(next_date).getDate() < 10)?'0'+new Date(next_date).getDate():new Date(next_date).getDate();
 
        stime = next_dates_y+next_dates_m+next_dates_d;
        
        //增加数组key
        i++;
    }
    console.log(diffdate);
    return diffdate
}




